"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _global = require("../../shared/global");

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var BigNumber = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-family: 'Playfair Display', serif;\n  font-feature-settings: 'lnum' 1;\n  font-size: 150px;\n  color: #176db6;\n  text-align: center;\n  span {\n    position: relative;\n    font-size: 30%;\n    bottom: 75px;\n    margin-right: 5px;\n    text-transform: uppercase;\n  }\n  @media (min-width: ", ") {\n    font-size: 200px;\n    span {\n      bottom: 100px;\n    }\n  }\n  @media (min-width: ", ") {\n    font-size: 160px;\n    span {\n      bottom: 80px;\n    }\n  }\n  @media (min-width: ", ") {\n    font-size: 220px;\n    span {\n      bottom: 110px;\n    }\n  }\n  @media (min-width: ", ") {\n    font-size: 300px;\n    span {\n      bottom: 150px;\n    }\n  }\n"])), _global.BREAKPOINTS[0], _global.BREAKPOINTS[1], _global.BREAKPOINTS[2], _global.BREAKPOINTS[3]);

var _default = {
  BigNumber: BigNumber,
  Percentage: (0, _styledComponents.default)(BigNumber)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    span {\n      bottom: 2em;\n    }\n  "])))
};
exports.default = _default;